import { StoryData, getStoryBySlug } from '@cinch-nx/data-storyblok'

import { HomeStoryContent } from '../types/home-story-content'

const isDev = process.env.STAGE_NAME !== 'production'

export const getHomePageContentData = async (
  preview = false,
): Promise<StoryData<HomeStoryContent> | null> => {
  const story = await getStoryBySlug<HomeStoryContent>('home', {
    version: preview ? 'draft' : 'published',
    ...(isDev && { cv: Date.now() }),
  })

  return story ?? null
}
